export default __webpack_public_path__ + "static/media/Login_1.6822c7e6.png";